import { render, staticRenderFns } from "./ImportShowScreen.vue?vue&type=template&id=45c96bb2&scoped=true&"
import script from "./ImportShowScreen.vue?vue&type=script&lang=js&"
export * from "./ImportShowScreen.vue?vue&type=script&lang=js&"
import style0 from "./ImportShowScreen.vue?vue&type=style&index=0&id=45c96bb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c96bb2",
  null
  
)

export default component.exports